import React, { useEffect, useState } from 'react'
import SifreInput from '../../components/SifreInput';
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import { AuthLayout } from '../../layouts/AuthLayout'
import { toAbsoluteUrl } from '../../_metronic/helpers/AssetHelpers'
import { Helpers } from '../../helpers/Helpers'
import toast from "react-hot-toast";
import { UserService } from '../../services/UserService'
import { LoginResponse } from '../../models/response/user/LoginResponse'
import { useDispatch, useSelector } from 'react-redux'
import { storeActivityIndicator, storeCompanyList, storeSelectedCompany, storeUser } from '../../redux/reducers/authSlice'
import ExpireStorage from '../../helpers/ExpireStorage'
import { GetCompanyListResponse } from '../../models/response/company/GetCompanyListResponse'
import { CompanyService } from '../../services/CompanyService'
import Box from '../../components/Box'
import { OTURUM_KAPANDI_ANAHTARI } from '../../helpers/AxiosInterceptor'

const LoginScreen = () => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false)
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [isCustomActive, setIsCustomActive] = useState(false);

    // Oturum sunucuda dustuyse (ornegin sifre degisti) sebebi bir kez gosterilir.
    useEffect(() => {
        const mesaj = sessionStorage.getItem(OTURUM_KAPANDI_ANAHTARI);

        if (mesaj) {
            sessionStorage.removeItem(OTURUM_KAPANDI_ANAHTARI);
            toast.error(mesaj);
        }
    }, []);

    const login = async () => {
        try {
            if (Helpers.isEmpty(username) || Helpers.isEmpty(password)) {
                toast.error('Kullanıcı adınız veya şifreniz boş olamaz!')
                return;
            }

            dispatch(storeActivityIndicator(true))

            var response: LoginResponse = await UserService.login(username, password);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            await ExpireStorage.setItem(Helpers.getStorageKeys()[0], JSON.stringify(response), response.data.expireInMinutes);
            await ExpireStorage.setItem(Helpers.getStorageKeys()[1], response.data.token, response.data.expireInMinutes);

            var response2: GetCompanyListResponse = await CompanyService.getCompanyList({ isCompany: true });

            if (!response2.isSuccess) {
                toast.error(response2.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            if (response2.data.length == 0) {
                toast.error('Şirket bulunamadı.')
                dispatch(storeActivityIndicator(false))
                return;
            }

            var selectedCompanyId = localStorage.getItem("SelectedCompanyId");
            var lastSelectedCompanyId = localStorage.getItem("LastSelectedCompanyId");

            if (lastSelectedCompanyId) {
                var controlCompany = response2.data.find(x => x.companyId == lastSelectedCompanyId);

                if (!controlCompany) {
                    localStorage.setItem("SelectedCompanyId", response2.data[0].companyId);
                    localStorage.setItem("LastSelectedCompanyId", response2.data[0].companyId);
                    selectedCompanyId = response2.data[0].companyId;
                }
                else {
                    localStorage.setItem("SelectedCompanyId", controlCompany.companyId);
                    localStorage.setItem("LastSelectedCompanyId", controlCompany.companyId);
                    selectedCompanyId = controlCompany.companyId;
                }
            }
            else {
                localStorage.setItem("SelectedCompanyId", response2.data[0].companyId);
                localStorage.setItem("LastSelectedCompanyId", response2.data[0].companyId);
                selectedCompanyId = response2.data[0].companyId;
            }

            window.location.reload();
            return;
            dispatch(storeCompanyList(response2.data))
            dispatch(storeSelectedCompany(response2.data.find(x => x.companyId == selectedCompanyId)));
            dispatch(storeUser({ isLoading: false, user: response }));
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
        finally {
            // dispatch(storeActivityIndicator(false))
        }
    }

    const onLoginSubmit = (e: any) => {
        e.preventDefault()
        login();
    }

    return (
        <AuthLayout>
            <form
                onSubmit={onLoginSubmit}
                className='form w-100'
            >
                <div className='text-center'>
                    <img alt='Logo' src={toAbsoluteUrl('media/misc/AI-CS6.png')} className='mb-10 h-175px' />
                </div>



                <div className='fv-row mb-8'>
                    <label className='form-label fs-6 fw-bolder text-gray-900'>Kullanıcı Adı / Telefon</label>
                    <input
                        className={'bg-white form-control'}
                        placeholder='Kullanıcı adı ya da telefon no giriniz'
                        onChange={(e) => setUsername(e.target.value)}
                        autoComplete='off'
                    />

                </div>

                <div className='fv-row mb-3'>
                    <label className='form-label fw-bolder text-gray-900 fs-6 mb-0'>Şifreniz</label>
                    <SifreInput
                        onChange={(e) => setPassword(e.target.value)}
                        autoComplete='off'
                        className={'form-control bg-white'}
                    />
                </div>

                <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8'>
                    <Box flexDirection='row' height='42px'>
                        <Box flex={1} justifyContent='center'>
                            <div className="form-check form-check-custom form-check-solid d-flex">
                                <input onChange={(e) => { setIsCustomActive(!isCustomActive) }} className="form-check-input" type="checkbox" value="" id={"deviceCrudIsCustomActiveYes"} checked={isCustomActive} />
                                <label className="form-check-label" htmlFor={"deviceCrudIsCustomActiveYes"}>
                                    Beni Hatırla
                                </label>
                            </div>
                        </Box>
                    </Box>

                    <Link to='/auth/forgot-password' className='link-primary'>
                        Şifremi Unuttum
                    </Link>
                </div>

                <div className='d-grid mb-10 justify-content-center'>
                    <button
                        type='submit'
                        id='kt_sign_in_submit'
                        className='btn btn-primary'
                        style={{ width: 'fit-content' }}
                    >
                        <span className='indicator-label'>Giriş Yap</span>
                    </button>
                </div>

                {/* <div className='text-gray-500 text-center fw-semibold fs-6'>
                    Not a Member yet?{' '}
                    <Link to='/auth/registration' className='link-primary'>
                        Sign up
                    </Link>
                </div> */}
            </form>
        </AuthLayout>
    )
}

export default LoginScreen;